import { render } from "./PilotDashboard.vue?vue&type=template&id=a4665430&scoped=true"
import script from "./PilotDashboard.vue?vue&type=script&lang=js"
export * from "./PilotDashboard.vue?vue&type=script&lang=js"

import "./PilotDashboard.vue?vue&type=style&index=0&id=a4665430&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4665430"]])

export default __exports__